export enum FACETS {
  FQ_ARCHIVEDATE = 'fq_archiveDate',
  FQ_VALIDDATE = 'fq_validDate',
  FQ_PAGETYPE = 'fq_pageType',
  FQ_PAGE_CATEGORY_TITLES = 'fq_pageCategoryTitles',
  FQ_CONTENTDATE = 'fq_contentDate',
  FQ_CLEARANCE_LEVEL = 'fq_confidentialLevel',
  FQ_PROFILE_FIELDS = 'fq_profileFields',
  FQ_PACKSTATE = 'fq_packState',
  FQ_RELEVANT_PERSON_NAMES = 'fq_relevantPersonNames',
  FQ_CATEGORY_SINGLE_ONE = 'fq_formApplicationItemCategorySingleOne',
  FQ_CATEGORY_SINGLE_TWO = 'fq_formApplicationItemCategorySingleTwo',
  FQ_CATEGORY_MULTI_ONE = 'fq_formApplicationItemCategoryMultiOne',
  FQ_CATEGORY_MULTI_TWO = 'fq_formApplicationItemCategoryMultiTwo',
  FQ_CREATOR_ID = 'fq_creatorId',
  FQ_EDITOR_ID = 'fq_editorId',
  FQ_BOOKMARKS = 'fq_bookmarks',
}
